import { smb_fetch, getAgpAgmsApiUrl } from '../../fetch';
import { SignFrameStatus } from '@/model/agency';

export interface newRealNameQRCodeParams {
  userId: number,
  authType: 'WX_PAY' | 'WX_FACE',
  validPeriod: number,
}

export type bmRealNameQRCodeParams = newRealNameQRCodeParams & {
  agentGroup?: string;
  isSvip: boolean;
  signFrameStatus?: SignFrameStatus;
};

export const newRealNameQRCode = (params: newRealNameQRCodeParams, isShowError = true) => {
  const { userId, authType, validPeriod } = params;
  const url = getAgpAgmsApiUrl('real_name/auth_code', 'create');

  return smb_fetch<any>(
    url,
    {
      method: 'POST',
      data: {
        user_id: userId,
        auth_type: authType,
        valid_period: validPeriod,
      },
    },
    isShowError,
  );
};

export const bmRealNameQRCode = (params: bmRealNameQRCodeParams, isShowError = true) => {
  const { userId, authType, validPeriod, agentGroup, isSvip, signFrameStatus } = params;
  const url = getAgpAgmsApiUrl('real_name/bm_auth_code', 'create');

  return smb_fetch<any>(
    url,
    {
      method: 'POST',
      data: {
        user_id: userId,
        auth_type: authType,
        valid_period: validPeriod,
        agent_group: agentGroup,
        is_svip: isSvip,
        sign_frame_status: signFrameStatus,
      },
    },
    isShowError,
  );
};


export const getUserCert = (userId: number) => {
  const url = getAgpAgmsApiUrl('user_cert', 'get');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    {
      data: {
        user_id: userId,
      },
    },
  );
  return smb_fetch<any>(url, params);
};

export const getUser = (userId: number) => {
  const url = getAgpAgmsApiUrl('user', 'get');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    {
      data: {
        user_id: userId,
      },
    },
  );
  return smb_fetch<any>(url, params);
};

export const checkSvip = () => {
  const url = getAgpAgmsApiUrl('svip_user_cert', 'provider/check');
  return smb_fetch<any>(url, {
    method: 'POST',
    data: {},
  }, false, false);
};

export const getSvipAuditStatus = (data: any) => {
  const url = getAgpAgmsApiUrl('svip_user_cert', 'user/status/get');
  return smb_fetch<any>(url, {
    method: 'POST',
    data,
  }, false, false);
};
